<template>
  <v-card-text class="pt-6">
    <div class="d-flex align-center ga-3">
      <v-icon color="red" size="30">mdi-alert-circle</v-icon>

      <div>
        <div class="text-body-1">
          {{ $t("delete_project_confirm") }}
          <b>{{ projectName }}</b>
        </div>

        <div class="text-body-2 text-medium-emphasis mt-1">
          {{ $t("delete_project_warning") }}
        </div>
      </div>
    </div>

    <v-divider class="my-6" />

    <div class="text-body-2">
      <b>{{ $t("project_key_label") }}:</b> {{ projectKey }} ·
      <b>{{ $t("client_label") }}:</b> {{ projectClient }} ·
      <b>{{ $t("qa_lead_label") }}:</b> {{ projectLead }}
    </div>
  </v-card-text>
</template>
<script>
export default {
  name: "ProjectDeleteInfo",

  props: {
    project: { type: Object, required: true },
  },

  computed: {
    projectName() {
      return (
        this.project?.nombre ?? this.project?.nameProyect ?? this.projectKey
      );
    },

    projectKey() {
      return this.project?.clave ?? this.project?.idProyect ?? "";
    },

    projectClient() {
      return this.project?.cliente ?? this.project?.UnitBussines ?? "-";
    },

    projectLead() {
      return (
        this.project?.qaLead ??
        this.project?.responsable ??
        this.project?.accountable ??
        "-"
      );
    },
  },
};
</script>